import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetContentAssetQuery } from '../../../services/content';

const LiveChat = () => {
    const { isChatEnabled } = useSelector(state => state.commonReducer);
    const { data: dataLiveChatUrl, isFetching: isFetchingLiveChatUrl } = useGetContentAssetQuery('contactus-chat-script');

    useEffect(() => {
        if (isChatEnabled && dataLiveChatUrl && !isFetchingLiveChatUrl) {
            const url = dataLiveChatUrl?.ContentValue;
            if (!url) return;
            const src = String(url);
            if (document.querySelector(`script[src="${src}"]`)) return;

            const isZoomSdk = /zcc-sdk\.js/i.test(src);
            const script = document.createElement('script');
            script.src = src;
            if (isZoomSdk) {
                script.type = 'module';
                script.setAttribute('data-apikey', 'DiNBv1H7RAi9VRjHgxeksQ');
                script.setAttribute('data-env', 'us01');
            } else {
                script.async = true;
            }

            document.body.appendChild(script);
        }
    }, [isFetchingLiveChatUrl]);
}

export default LiveChat;
